import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Gdpr } from 'components/pages/PageProfile/Gdpr';
import { isAuthSelector } from 'modules/user/selectors';

const mapActionCreators = (dispatch: Dispatch) => ({});

const mapStateToProps = (state: State.Root) => ({
  isAuth: isAuthSelector(state),
});

export const GdprContainer = connect(mapStateToProps, mapActionCreators)(Gdpr);
